import { faFileEdit } from '@fortawesome/pro-regular-svg-icons';
import { faEye, faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getArticleTitleAsHTML } from 'mk2/apps/blogs/containers/Article/Article.helpers';
import { getPostDate } from 'mk2/apps/blogs/helpers';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import { strollersArticlesOfSectionUrl } from 'mk2/apps/strollers/urls';
import { BadgeType, BADGE_CONFIGS } from 'mk2/components/Badge';
import { BreadcrumbSiteStructure } from 'mk2/components/BreadcrumbSiteStructure';
import { Emojify } from 'mk2/components/Emojify';
import { Link } from 'mk2/components/Link';
import { dateLocal } from 'mk2/helpers/timeformat';
import { url } from 'mk2/helpers/urls';
import { BlogPostEntity, PostVisibility } from 'mk2/schemas';
import React from 'react';
import styles from './ArticleHeader.mscss';

export interface BreadcrumbInput {
    itemUrl: string;
    itemLabel: string;
}

interface OwnProps {
    article: Pick<
        BlogPostEntity,
        'createdAt' | 'user' | 'visibility' | 'viewsCountTotal' | 'titleAST' | 'titleASTAdditionalData' |
        'hashtagItems' | 'lastChanged' | 'isPublished'
    >;
    hashtagBadgeTypes?: BadgeType[];
    breadcrumbInputs: BreadcrumbInput[];
}

type Props = OwnProps;

export default class ArticleHeader extends React.Component<Props> {

    private static getBreadcrumbItems(breadcrumbInputs: BreadcrumbInput[]) {
        const breadcrumbItems = [];
        return breadcrumbInputs.reduce((acc, { itemUrl, itemLabel }, index) => {
            if (itemUrl) {
                acc.push(
                    <Link className={styles.BreadcrumbItem} key={index} to={itemUrl}>
                        {itemLabel}
                    </Link>,
                );
            } else {
                acc.push(
                    <React.Fragment key={index}>
                        {itemLabel}
                    </React.Fragment>,
                );
            }
            return acc;
        }, breadcrumbItems);
    }

    public render() {
        const {
            article,
            hashtagBadgeTypes,
            breadcrumbInputs,
        } = this.props;

        const showViewsCount =
            article.viewsCountTotal > 0 ||
            // views sa meraju iba pre clanky vytvorene po 2015-11-05 14:00 utc
            (article.createdAt && Date.parse(article.createdAt) >= Date.UTC(2015, 11, 5, 14, 0, 0));

        return (
            <div className={styles.ArticleHeader}>
                {!!breadcrumbInputs?.length && (
                    <BreadcrumbSiteStructure
                        items={ArticleHeader.getBreadcrumbItems(breadcrumbInputs)}
                        className={styles.ArticleHeader__breadcrumb}
                    />
                )}
                <div className={styles.ArticleHeader__meta}>
                    <UserChip user={article.user} size={24} boldUsername />

                    <div className={styles.ArticleHeader__metaDate}>{dateLocal(getPostDate(article))}</div>

                    {showViewsCount && (
                        <div className={styles.ArticleHeader__metaViews}>
                            {article.viewsCountTotal}&nbsp;
                            <FontAwesomeIcon icon={faEye} />
                        </div>
                    )}

                    {article.visibility !== PostVisibility.Public && (
                        <div className={styles.ArticleHeader__metaVisibility}>
                            <FontAwesomeIcon icon={faLock} />
                        </div>
                    )}

                    {!article.isPublished && (
                        <div className={styles.ArticleHeader__metaIsDraft}>
                            <FontAwesomeIcon icon={faFileEdit} />
                        </div>
                    )}
                </div>

                {!!hashtagBadgeTypes?.length && (
                    <div className={styles.ArticleHeader__hashtags}>
                        {hashtagBadgeTypes.map((type, index) => {
                            const badge = <>
                                {BADGE_CONFIGS[type].icon
                                    ? <FontAwesomeIcon
                                        icon={BADGE_CONFIGS[type].icon}
                                        className={styles.ArticleHeader__hashtags__item__icon}
                                    />
                                    : null}
                                {BADGE_CONFIGS[type].label}
                            </>;
                            return BADGE_CONFIGS[type].sectionSlug ? (
                                <Link
                                    key={index}
                                    className={styles.ArticleHeader__hashtags__item}
                                    to={url(strollersArticlesOfSectionUrl, { sectionSlug: BADGE_CONFIGS[type].sectionSlug })}
                                >
                                    {badge}
                                </Link>
                            ) : badge;
                        })}
                    </div>
                )}

                <h1 className={styles.ArticleHeader__title}>
                    <Emojify size={26}>{getArticleTitleAsHTML(article)}</Emojify>
                </h1>
            </div>
        );
    }
}
